module.exports = __webpack_public_path__ + "static/media/creator2.cb154a19.jpg";